import React from "react";

const GlobalIcon = props => (
    <svg {...props} fill="currentcolor" width="32" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048">
        <path d="M1024,256.8c-423.1,0-766.1,343-766.1,766.1S600.9,1789,1024,1789s766.1-343,766.1-766.1
            S1447.1,256.8,1024,256.8z M1481,1269.2l17.1,51.9l-26.6,53.3l-53.4,52L1379,1470l-70.1,76.5c-16.7,18.3-83.8,87.2-149.8,107.5
            h-108.4l82.9-75.7l22.3-41.4l19.1-51l-16.9-35.9l-70.6-30.3l-50.3-68.2l-22.1-63.2l12.5-65.1L855,1130.4l-96-58.6l-75.7-88.2
            l-64.4-40.7l-34-110.5l29.8-85l-29.8-93.5l35.4-57.4l89.3-114.8c39.5-29.7,82.1-32,128-51.8l43.5-16l55.4,48l52.1,23.2l50.3,78.8
            l71.3,6.2l98.8,24.7l-33.2,76.1l-51,29.8l-37.3,36.1l-29.7,33.9l-33.7,6.5l-18.3,25.5l-21.2,110.5l-68.4-52.1l-29.4,1.1l-36.9,21.3
            l-25.5,51l34.5,74.8l36.8,58l85.4,40.4l99.3-8.2l70.9-28.6l84.3,3.8l54.2,39.4l46.3,54.7l100.2,16.5l26.8,38L1481,1269.2z"/>
    </svg>

);

export default GlobalIcon;